/*=========================================================================================
  File Name: store.js
  Description: Vuex store

==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import profile from './modules/profile.js'
import notifications from "@/store/modules/notifications";
import tasks from "@/store/modules/tasks";


Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: [profile, notifications, tasks],
  strict: process.env.NODE_ENV !== 'production'
})
